// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GuestLazyComponent" + "." + "2489e441fa1b598078f6" + ".js";
};